export default __webpack_public_path__ + "static/abel2020small-1c9e884bcd8eb6dabb3a4c6cd40f30f8.jpg";